import Swiper from "swiper";
import {TweenMax} from "gsap";
import {TimelineMax} from "gsap";
import ScrollMagic from "scrollmagic";
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
const controller = new ScrollMagic.Controller;
/**
 * トップ
 * @constructor
 */
class Top {
  constructor() {
    this.pc = window.matchMedia("(min-width: 751px)").matches;
    this.sp = window.matchMedia("(max-width: 750px)").matches;
    this.sct = $(window).scrollTop();
    this.wh = $(window).height();
    this.sctBottom = this.sct + this.wh;
    this.size = $('.is-slideUp').length;
    this.targetY = [];
  }
  /**
   * サンプル
   */
  init() {
    this.kvSliderInit();
    //タブ切り替え
    $('.p-top__symptomsTabItem').on("click", (e)=> {
      this.tabChange(e.currentTarget);
    })
    this.viewMessageInit();
    $(window).on('scroll',()=>{
      this.sct = $(window).scrollTop();
      this.wh = $(window).height();
      this.sctBottom = this.sct + this.wh;
      this.viewMessage();
    })
//    //メッセージエリアの挙動
//    const message = new TimelineMax();
//    message.to('.is-slideUp', 0.3, {
//      opacity: 1,
//      marginTop:0
//    })
//    new ScrollMagic.Scene({
//      triggerHook: "onLeave",
//      triggerElement: '.p-top__message',
//      offset: '-200',
//      duration: '1000',
//      reverse: false,
//    })
//    .setTween(message)
////    .addIndicators({name: "message"})
//    .addTo(controller);

  }
  kvSliderInit(){
    //kvのスライダー
    new Swiper('.swiper-container--kv', {
      loop: true,
      effect: "fade",
      speed: 800, //1秒かけながら次の画像へ移動
      autoplay: {
        delay: 3000, //2秒後に次の画像へ
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    })

    //コラムのスライダー
    if(this.sp) {
      new Swiper('.swiper-container--column', {
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        speed: 500,
        initialSlide: 0,
        slidesPerView: 1,
        centeredSlides : true,
        slideToClickedSlide: true,
        loopAdditionalSlides: 1,
        spaceBetween: 10,
      })
    }
  }
  tabChange(el){
    const tabs = $('.p-top__symptomsTabItem');
    $('.active').removeClass('active');
    $(el).addClass('active');
    const index = tabs.index(el);
    $('.p-top__symptomsContent').removeClass('show').eq(index).addClass('show');
  }
  viewMessageInit(){
    for(let i = 0; i<this.size; i++){
      this.targetY[i] = $('.is-slideUp').eq(i).offset().top;
    }
  }
  viewMessage(){
    for(let i = 0; i<this.size; i++){
      if( this.targetY[i] < this.sctBottom){
        $('.is-slideUp').eq(i).addClass('is-active');
      }

    }

  }
};

export default Top;
